(function (angular) {

    angular.module('app.purchase')
        .directive('planSummary', planSummaryDirective);

    var planSummaryController = [
        '$scope', '$state', 'app.purchase.purchaseFlowService', 'ui','$location', function ($scope, $state, purchaseFlowService, ui,$location) {
            var vm = this;

            vm.purchase = $scope.purchase;
            vm.selectedPlan = vm.purchase.selectedPlan;
            vm.adminFee = vm.purchase.adminFee;
            vm.promoCode = vm.purchase.promoCode;
            vm.applyPromoCode = applyPromoCode;
            vm.promoCodeTextValid = true;

            vm.planName = siteContent.copyright.planName;
            vm.siteContent = siteContent;
            vm.staticPromoCode = siteContent.site.purchaseFlow.staticPromoCode;
            vm.allowPromoCode = siteContent.site.purchaseFlow.allowPromoCode;

            if (vm.staticPromoCode && vm.staticPromoCode !== '' 
                && (!vm.promoCode || vm.promoCode === null)) {
                    vm.promoCode = vm.staticPromoCode;
                    vm.applyPromoCode();
            }

            function applyPromoCode() {
                ui.block();
                purchaseFlowService.applyPromoCode(vm.promoCodeText).then(function (data) {
                        if (data) {
                            vm.purchase = data;
                        }
                        else {
                            vm.promoCodeTextValid = false;
                        }
                    },
                    function () {
                        vm.promoCodeTextValid = false;
                    }).finally(function () {
                    ui.unblock();
                    $scope.$emit('priceChanged', vm.purchase);
                });
            }

            populatePromoCode();
            function populatePromoCode() {
                // if a promo code exists in local storage via ad campaign (see app.controller.js)
                var promoCode = parseLocalStoragePromoCode();
                if (promoCode) {
                    // populate promo code and apply it
                    setTimeout(function() {
                        $('#pCode').val(promoCode).trigger('change');
                        $('input[name="apply"]').click();
                    }, 1000);
                }
            }

            function parseLocalStoragePromoCode() {
                // Return promo code from local storage
                var object = JSON.parse(localStorage.getItem('promoCode'));
                if(object) {
                    promoCode = object.value;
                    return promoCode;
                }
            }

            vm.isOnApplicationPage = function() {
                return $location.path() === '/plans/application';
            };
        }
    ];

    function planSummaryDirective() {
        return {
            restrict: 'E',
            scope: {
                purchase: '='
            },
            templateUrl: '/app/site/purchase-flow/plan-summary/plan-summary.html',
            controller: planSummaryController,
            controllerAs: 'vm'
        };
    };

}(angular));